import { FormGroup, Validators, FormControl } from '@angular/forms';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { ApproveOrRejectGQL } from '../../../../generated/gatewaygql';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UpdateServiceRequestGQL } from '../../../../generated/cloudapigql';
import { AuthenticationService } from '../../../../services/authentication.service';

export interface RequestDetail {
  ID: string;
  lUnitId: number;
  publicAreaId: string;
  requestTitle: string;
  requestType: string;
}

export interface Unit {
  unitId: number;
  unitNo: string;
}

export interface DialogData {
  requestDetail: RequestDetail,
  areaTypes: string[],
  units: Unit[],
  requestTypes: string[],
  publicArea: string[]
}


@Component({
  selector: 'app-edit-service-request-dialog',
  templateUrl: './edit-service-request-dialog.html',
})
export class EditServiceRequestDialog implements OnInit {
  result: DialogData;
  form: FormGroup;
  constructor(
    public dialogRef: MatDialogRef<EditServiceRequestDialog>,

    // private
    @Inject(MAT_DIALOG_DATA) private _data: DialogData,
    private updateServiceRequestGQL: UpdateServiceRequestGQL,
    private _snackBar: MatSnackBar,
    private _authService: AuthenticationService
  ) {
    if (_data != null) {
      this.result = _data;
    }

  }

  ngOnInit() {
    let previousUnit: Unit = this.result.units.find(x => x.unitId == this.result.requestDetail.lUnitId);

    this.form = new FormGroup({
      areaType: new FormControl(),
      requestType: new FormControl(this.result.requestDetail.requestType),
      title: new FormControl(this.result.requestDetail.requestTitle),
    });
    if (this.result.requestDetail.lUnitId) {
      this.form.addControl("unit", new FormControl(previousUnit));
      this.form.get('areaType').setValue(this.result.areaTypes.find(x => x == "Unit"));
    } else if (this.result.requestDetail.publicAreaId) {
      this.form.addControl("publicArea", new FormControl(this.result.requestDetail.publicAreaId, [Validators.required]));
      this.form.get('areaType').setValue(this.result.areaTypes.find(x => x == "Public Area"));
    }

    this.form.get('areaType').valueChanges.subscribe(value => {
      if (value == "Unit") {
        this.form.removeControl("publicArea");
        this.form.addControl("unit", new FormControl(previousUnit ?? this.result.units[0]));
      }
      else {
        this.form.removeControl("unit");
        this.form.addControl("publicArea", new FormControl(this.result.requestDetail.publicAreaId ?? this.result.publicArea[0], [Validators.required, Validators.maxLength(250)]));
      }
    });
  }

  onSubmit(item: any) {
    let updateModel = this.form.value;
    // console.log("updateModel : ",updateModel);
    this.updateServiceRequestGQL.mutate({
      UpdateServiceRequestModel: {
        propertyId: this._authService.userInfo.property?.propertyId,
        unitNo: updateModel.unit?.unitNo,
        requestId: this.result.requestDetail.ID,
        publicAreaDesc: updateModel.publicArea,
        requestType: updateModel.requestType,
        title: updateModel.title,
        unitId: updateModel.unit?.unitId
      }
    }).subscribe(x => {
      if (x.data.updateServiceRequest == false) {
        // this.dialogRef.close(false);
        // this._snackBar.open('Error: ' + x.data.ApproveOrReject.message, 'Dismiss', { duration: 5000 });
      } else {
        this.dialogRef.close(true);
      }
    });
  }
}
